module.exports = __webpack_public_path__ + "img/1485524055.b9716793.jpg";